import { __awaiter } from "tslib";
import { CurrentAppPermissionsEventTypes, } from '@office-start/device-permission-types';
import { PermissionStatus, } from '@office-start/metaos-hub-sdk';
import { getHubSdkDevicePermission } from './getHubSdkDevicePermission';
const updateAppPermissions = ({ storageService, updatedDevicePermissions, }) => Promise.all(updatedDevicePermissions.map((permission) => __awaiter(void 0, void 0, void 0, function* () {
    const hubSdkDevicePermission = getHubSdkDevicePermission({
        permissionToTranslate: permission.devicePermission,
    });
    if (hubSdkDevicePermission === undefined) {
        return Promise.reject('failed to convert app definition permissions: permission not supported');
    }
    const permissionCurrentState = yield storageService.getPermissionStatus(hubSdkDevicePermission);
    if (permission.isConsentGivenOnCurrentDevice === true) {
        return yield storageService.storePermissionConsent({
            permission: hubSdkDevicePermission,
            status: PermissionStatus.Consented,
        });
    }
    if (permissionCurrentState === PermissionStatus.NeverAsked) {
        return yield storageService.storePermissionConsent({
            permission: hubSdkDevicePermission,
            status: permissionCurrentState,
        });
    }
    return yield storageService.storePermissionConsent({
        permission: hubSdkDevicePermission,
        status: PermissionStatus.Revoked,
    });
})));
const appPermissionsDialogEventHandler = (event, actions) => {
    var _a, _b;
    const novaEvent = event &&
        event;
    if (novaEvent.type ===
        CurrentAppPermissionsEventTypes.savePermissionsChange &&
        novaEvent.data) {
        const eventData = novaEvent.data();
        (_a = actions.currentAppPermissionsDialogSaveEvent) === null || _a === void 0 ? void 0 : _a.call(actions, eventData.permissionTypes);
    }
    else if (novaEvent.type ===
        CurrentAppPermissionsEventTypes.cancelPermissionsChange) {
        (_b = actions.currentAppPermissionsDialogCancelEvent) === null || _b === void 0 ? void 0 : _b.call(actions);
    }
    else {
        throw new Error(`AppPermissionsDialogEventHandler Error: NovaEvent.type was invalid: ${novaEvent.type}`);
        // TASK: 7869385;
        // we want to add area which is this file and the event type that was passed as well as saying this should be a manifest error log via logApphostError
        // logError({
        //     eventName: 'MOS_App_Host_Error',
        //     errorType: 'App_Permissions_Dialog_Event_Type_Error',
        //     debugInfo: `${JSON.stringify({ eventType: novaEvent.type })}`,
        //     area: 'MOSAppHost',
        // });
    }
};
export const getAppPermissionsDialogEventHandler = (event, { devicePermissionsStorage, closeAppPermissionsDialog, setPermissionsState, }) => {
    const currentAppPermissionsDialogSaveEvent = (devicePermissions) => {
        devicePermissionsStorage &&
            updateAppPermissions({
                storageService: devicePermissionsStorage,
                updatedDevicePermissions: devicePermissions,
            });
        setPermissionsState(devicePermissions);
        closeAppPermissionsDialog();
    };
    const currentAppPermissionsDialogCancelEvent = () => {
        closeAppPermissionsDialog();
    };
    return appPermissionsDialogEventHandler(event, {
        currentAppPermissionsDialogSaveEvent,
        currentAppPermissionsDialogCancelEvent,
    });
};
//# sourceMappingURL=getAppPermissionsDialogEventHandler.js.map